module.exports = __webpack_public_path__ + "img/40_55.f3a5c171.png";